import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

import { bodyAvailableReceivables } from './createAvailableReceivables';

export type editAvailableReceivablesDataType = {
  id: string;
  body: bodyAvailableReceivables;
  successCallback?: Function;
  errorCallback?: Function;
  resultKey?: string;
};

export default ({
  id,
  body,
  successCallback,
  errorCallback,
  resultKey = 'EditAvailableReceivables',
}: editAvailableReceivablesDataType) =>
  requestAsync({
    url: endpoints.getEditAvailableReceivablesUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: `${endpoints.getEditAvailableReceivablesUrl(id)}`,
    body,
    options: {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
